/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_TitleInputs */

const en_blog_title = /** @type {(inputs: Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const zh_blog_title = /** @type {(inputs: Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_title = /** @type {((inputs?: Blog_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_title(inputs)
	return zh_blog_title(inputs)
});
export { blog_title as "blog.title" }